<template>
	<div class='cgs'>
		<div class="shadow"></div>
		<div class='cgs_wrap'>
			<img src="~@img/cgs.png" alt="logo">
			<h1>Congratulations!</h1>
			<p class='words'>Your account has been created successfully. Let's get you 
started in your application to become a HAWO teacher.</p>
			<a class='started' @click="started">Let's get started</a>
			<p class='timeout'>{{time_out}}</p>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			time_out:'5s',
			time:5,
			timer:""
		}
	},
	methods :{
		started :function(){
			clearTimeout(this.timer)
			this.$router.push('fillform')
		},
		time_out_func :function(){
			let _this=this
			this.timer=setTimeout(function(){
				_this.time--
				if(_this.time==0){
					_this.started()
					clearTimeout(timer)
					return
				}
				_this.time_out=_this.time+'s'
				_this.time_out_func()
			},1000)
		}
	},
	beforeRouteLeave:function(to,from,next){
		clearTimeout(this.timer)
		next()
	},
	beforeRouteEnter:function(to,from,next){
		next(
			vm => {
				if(vm.time==5){
					vm.time_out_func()
				}else{
					vm.time_out=''
				}
			}
		)
	}
}
</script>

<style lang='less' scoped>
.cgs{
	height:975px;
	background:url("~@img/creat_acount_bg.jpg") no-repeat center center;
}
.shadow{
	background: #fff;
	opacity: 0.1;
	position: absolute;
	left:50%;
	top:232px;
	transform: translateX(-50%);
	z-index:1;
	width:837px;
	height:535px;
	border-radius: 10px;
}
.cgs_wrap{
	position: absolute;
	left:50%;
	top:232px;
	transform: translateX(-50%);
	width:836px;
	height:535px;
	color:#aeaeae;
	z-index:2;
	text-align: center;
	img{
		padding-top: 80px;
	}
	h1{
		padding-top:25px;
		font-size:30px;
		color:#fffefe;
	}
	p.words{
		width:495px;
		margin:0 auto;
		padding-top: 40px;
		font-size:18px;
		color:#fffefe;
	}
	a.started{
		display: block;
		cursor:pointer;
		width:396px;
		height:46px;
		border-radius: 15px;
		background:#ffc000;
		margin:0 auto;
		margin-top:70px;
		font-size:24px;
		color:#010000;
		line-height:46px;
		text-align: center;
	}
	p.timeout{
		padding-top: 20px;
		text-align: center;
		color:#ffffff;
	}
}
</style>



// WEBPACK FOOTER //
// congratulations.vue?8cbc66b2